/*=========================================================================================
  File Name: moduleMap.js
  Description: Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleMatchFilterState.js";
import mutations from "./moduleMatchFilterMutations.js";
import actions from "./moduleMatchFilterActions.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
